<template>
    <jet-dialog-modal
        :show="true"
        @close="$emit('close')"
        ref="modal"
    >
        <template #title> Add a Contact to {{ groupTitle }} </template>

        <template #content>
            <form>
                <div class="tra__message-form flex flex-wrap relative">
                    <div class="w-full">
                        <label
                            class="w-full block text-gray-700"
                            for="contact_id"
                            >Contact</label
                        >
                        <contact-select v-model="contacts" @contact-created="newContactWasCreatedAndAddedToList" />
                        <jet-input-error
                            :message="form.errors.contact_id"
                            class="mt-2"
                        />
                    </div>
                </div>
            </form>
        </template>

        <template #footer>
            <button class="mr-4" @click="$emit('close')">
                Cancel
            </button>

            <jet-secondary-button
                @click="submitHandler()"
                :disabled="form.processing"
            >
                Add to List
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import { useGeneralTableStore } from '@/Stores/general_table';
import {mapWritableState, mapActions} from 'pinia';

export default {
    emits: ['close'],
    components: {
    },
    name: "GroupCreateModal",
    props: {
        groupTraId: {
            type: String
        },
        groupTitle: {
            type: String
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                contacts: []
            }, {
                bag: "createGroup",
                resetOnSuccess: true
            }),
            contacts: [],
        };
    },
    methods: {
        ...mapActions(useGeneralTableStore, ['clearData', 'fetchData']),
        submitHandler() {
            this.$inertia.post(
                route("groups.addContact.submit.json", this.groupTraId),
                this.form,
                {
                    onSuccess: page => {
                        this.resetValues();

                        this.$emit('close');
                        this.clearData({resetPage: false});
                        this.fetchData(); // general store call to refresh any affected tables if needed
                    },
                    onError: errors => {
                        this.$toasted.show(errors.contacts, {
                            position: "bottom-right",
                            duration: 2000,
                            type: "error"
                        });
                    }
                }
            );
        },

        newContactWasCreatedAndAddedToList(contactId) {
            this.form.contacts = [contactId];
            this.submitHandler();
        },
        resetValues() {
            this.contacts = []
        }
    },
    computed: {
    },
    watch: {
        contacts(value) {
            var ids = value.map(a => a['id']);
            this.form.contacts = ids;
        },
    }
};
</script>

<style scoped></style>
